module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAElBMVEUAAADX4//P1//X3f/V3f/W3f8STY4fAAAABXRSTlMAHxB/f74q65wAAAAwSURBVDjLYxjqgEkQAyhApVxDMUAIVFMoFqBASIrBFFMmGJ8zRsFofA11MBpfNAMA8xVX3Fpyke8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/public/wapIcon.png
// module id = jmAs
// module chunks = 0